import { useLayoutVisibility } from "@/components/Layout/Contexts/LayoutVisibility/LayoutVisibilityContext";
import { api } from "@/lib/api";
import { type Schemas } from "@/types";
import { useQuery } from "react-query";

export default function RecentLeadsTabQuery() {
  const { activeNavbar } = useLayoutVisibility();
  const isSalesAndServiceApp = activeNavbar === "Sales & Service";

  const { data } = useQuery({
    queryKey: ["recentLeadsHomeStats"],
    queryFn: async () => {
      const response = await api.get<Schemas["RecentLeadsHomeStats"]>(
        "/api/Reports/RecentLeadsHomeStats",
      );
      return response.data;
    },
    enabled: !isSalesAndServiceApp,
  });

  return {
    totalNew: isSalesAndServiceApp ? 0 : data?.totalNew,
    totalSpaceTour: isSalesAndServiceApp ? 0 : data?.totalSpaceTour,
    totalWonToday: isSalesAndServiceApp ? 0 : data?.totalWonToday,
    totalLostToday: isSalesAndServiceApp ? 0 : data?.totalLostToday,
  };
}
